import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { StyleSheet, css } from 'aphrodite';
import { push as pushAction } from 'react-router-redux';
import R from 'ramda';
import {
  IconMenu,
  MenuItem,
  FontIcon,
  IconButton,
  FlatButton,
  TableRow,
  TableRowColumn,
} from 'material-ui';
import CancelConfirm from './cancel-confirm-buttons';
import SendContract from 'material-ui/svg-icons/content/send';
import ArchiveIcon from 'material-ui/svg-icons/content/archive';
import UnarchiveIcon from 'material-ui/svg-icons/content/unarchive';
import queryString from 'query-string';
import { downloadContractPdf as downloadContractPdfAction } from '../../../../stores/contracting/template-list/template-list-actions';
import { getTemplateStatusColor } from '../../contractingUtils';
import StagedUpdatesText from '../../generic-components/template-staged-updates-text-flag';
import WallWrapper from '../../../wall/wrapper';

const getGenitiveCase = (string) => {
  if (!string) return string;
  if (string.slice(-1) === 's') return `${string}'`;
  return `${string}'s`;
};

const styles = StyleSheet.create({
  container: {
    height: '56px',
    display: 'flex',
    paddingLeft: '16px',
    alignItems: 'center',
    cursor: 'pointer',
  },
  texts: { width: '66%', color: 'rgba(0, 0, 0, 0.77)', height: '56px', paddingTop: '5px' },
  companyName: {
    fontSize: '14px',
    color: '#00838f',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '90%',
  },
  locationName: { fontSize: '13px' },
  actions: {
    width: '20%',
    marginLeft: '1%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  commentsButton: { padding: '0', height: '24px', width: '24px', top: '4px' },
  yearNtimestamp: {
    color: 'rgba(0, 0, 0, 0.77)',
    flexDirection: 'column',
    textAlign: 'right',
    width: '10%',
  },
  comments: { marginLeft: '8px', width: '10%', cursor: 'pointer' },
});

const TemplateRow = ({
  style,
  isTemplate,
  template,
  viewTemplate,
  viewPartners,
  updateTemplateProps,
  deleteTemplate,
  archiveUnarchive,
  saveNewTemplateName,
  doNotShowActionButtons,
  showLocName,
  downloadContractPdf,
  companyName,
  openDialogSaveAsTemplate,
  push,
}) => {
  const {
    _id,
    partnersCount,
    templateHasDraft,
    templateName,
    stagedUpdates = [],
    updateInitiated,
    startDate,
    endDate,
    locationId,
    locationName,
  } = template;
  const showCancelConfirm = template.showDeleteConfirmButton || template.showEditNameConfirmButton;
  // if (!R.contains('read', template.access)) {
  //   return (
  //     <NoAccessRow
  //       locationName={locationName}
  //       templateName={templateName}
  //       doc={template}
  //       showLocName={showLocName}
  //       style={style}
  //     />
  //   );
  // }
  const goToSendAssets = () => window.location = `${
    process.env.NEW_SYSTEM_URL
  }/partner-management/send-assets?${queryString.stringify({
    go_back_to: window.location.href,
    templateids: [template._id],
    message: `Please find ${getGenitiveCase(template.locationName === companyName ? template.locationName : `${template.locationName } - ${companyName}`)} ${moment(startDate).utc().format('DD MMM YYYY')} - ${moment(endDate).utc().format('DD MMM YYYY')} rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.`,
    subject: `${getGenitiveCase(template.locationName === companyName ? template.locationName : `${template.locationName } - ${companyName}`)} ${moment(startDate).utc().get('year')}-${moment(endDate).utc().get('year')} Rates`,
  })}&jwt=${localStorage.getItem('jwt')}`;
  return (
    <TableRow
      className={`templateRow`}
      selectable={false}
      style={{ overflow: 'visible', ...style }}
    >
      <TableRowColumn
        colSpan="20"
        style={{ padding: '0 0 0 16px', fontSize: '14px', color: '#00838f', cursor: 'pointer' }}
      >
        <div onClick={viewTemplate}>
          {!template.showEditNameConfirmButton ? (
            <div>
              <FontIcon
                className="tc-icon-description"
                color="rgba(0, 0, 0, 0.64)"
                style={{ fontSize: '18px', top: '2px' }}
              />
              {templateName}{' '}
              <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                {!R.contains('write', template.access) ? '(READ-ONLY)' : ''}
              </span>
            </div>
          ) : (
            <input
              style={{ height: '32px', width: '90%' }}
              autoFocus
              onClick={e => e.stopPropagation()}
              value={template.newTemplateName}
              onChange={({ target: { value } }) =>
                updateTemplateProps({ newTemplateName: value, errorText: '' })
              }
            />
          )}
          <div className={css(styles.locationName)}>
            {showLocName ? (
              <span>
                <FontIcon
                  className="tc-icon-location_on"
                  color="rgba(0, 0, 0, 0.54)"
                  style={{ fontSize: '14px' }}
                />
                {locationName}&nbsp;
              </span>
            ) : (
              <span />
            )}
            {(() => {
              if (stagedUpdates.length) {
                return (
                  <StagedUpdatesText
                    stagedUpdates={stagedUpdates}
                    updateInitiated={updateInitiated}
                    isEditedTemplate={templateHasDraft}
                    refreshSection="list"
                  />
                );
              }
              if (templateHasDraft) {
                return (
                  <span style={{ marginLeft: '12px', color: 'red', zIndex: '200' }}>
                    This template has a{' '}
                    <Link
                      onClick={e => e.stopPropagation()}
                      to={`/contracting/draft/${template._id}/details`}
                    >
                      draft
                    </Link>
                    .
                  </span>
                );
              }
            })()}
          </div>
        </div>
      </TableRowColumn>
      {!showCancelConfirm
        ? [<TableRowColumn key="partners" colSpan="3" style={{ textAlign: 'center', padding: 0 }}>
              {isTemplate && (
                <FlatButton
                  secondary
                  onTouchTap={viewPartners}
                  className={`partnersCount ${css(styles.comments)}`}
                  icon={<FontIcon className="tc-icon-users" />}
                  label={`${partnersCount || 0}`}
                />
              )}
            </TableRowColumn>,
            <TableRowColumn key="status" colSpan="3" style={{ textAlign: 'center', padding: 0 }}>
              <div style={{ color: getTemplateStatusColor(template.shownStatus), padding: 0 }}>
                {template.shownStatus}
              </div>
            </TableRowColumn>,
            <TableRowColumn key="period" colSpan="3" style={{ textAlign: 'center', padding: 0 }}>
              {`${new Date(template.startDate).getUTCFullYear()}-${new Date(
                template.endDate,
              ).getUTCFullYear()}`}
            </TableRowColumn>,
            <TableRowColumn key="timestamp" colSpan="3" style={{ textAlign: 'center', padding: 0 }}>
              <span style={{ fontSize: '11px', color: 'rgba(0, 0, 0, 0.45)' }}>
                {moment(template.updatedAt).calendar(null, {
                  sameDay: '[Today]',
                  lastDay: '[Yesterday]',
                  lastWeek: '[Last] dddd',
                  sameElse: 'DD/MM/YYYY',
                })}
              </span>
            </TableRowColumn>,
            <TableRowColumn
              key="actions"
              colSpan="4"
              style={{
                overflow: 'visible',
                textAlign: 'center',
                padding: 0,
                display: doNotShowActionButtons ? 'none' : '',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  disabled={!isTemplate}
                  tooltip="Download Template"
                  tooltipPosition="top-right"
                  onClick={e => e.stopPropagation()}
                  style={{ padding: '0', width: '48px', height: '24px' }}
                  onTouchTap={e => downloadContractPdf(template._id, e.currentTarget)}
                >
                  <FontIcon className="tc-icon-get_app" color="rgba(0, 0, 0, 0.54)" />
                </IconButton>
                <IconButton
                  disabled={!isTemplate}
                  tooltip="Send Template"
                  tooltipPosition="top-right"
                  onClick={e => e.stopPropagation()}
                  style={{ padding: '0', width: '36px', height: '24px' }}
                  onTouchTap={goToSendAssets}
                >
                  <SendContract color="rgba(0, 0, 0, 0.54)" />
                </IconButton>
                <IconMenu
                  iconButtonElement={
                    <IconButton
                      iconClassName="tc-icon-more-vert"
                      iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', top: '2px' }}
                      style={{ padding: '0', width: '24px', height: '24px' }}
                    />
                  }
                >
                  <MenuItem
                    leftIcon={
                      <FontIcon
                        className="tc-icon-delete2"
                        color={Boolean(partnersCount) ? '#e0e0e0' : 'red'}
                      />
                    }
                    primaryText="Delete Template"
                    disabled={Boolean(partnersCount)}
                    onTouchTap={() => updateTemplateProps({ showDeleteConfirmButton: true })}
                  />
                  {isTemplate && (
                    <MenuItem
                      leftIcon={template.isArchived ? <UnarchiveIcon /> : <ArchiveIcon />}
                      primaryText={template.isArchived ? 'Unarchive Template' : 'Archive Template'}
                      onTouchTap={archiveUnarchive}
                    />
                  )}
                  <MenuItem
                    leftIcon={<FontIcon className="tc-icon-mode_edit" color="#00bcd4" />}
                    primaryText="Edit Template Name"
                    onTouchTap={() =>
                      updateTemplateProps({
                        showEditNameConfirmButton: true,
                        newTemplateName: template.templateName,
                      })
                    }
                  />
                  {
                    isTemplate && (
                      <WallWrapper amazonOrange>
                        <MenuItem
                          leftIcon={<FontIcon className="tc-icon-swap_horiz" color="#00bcd4" />}
                          primaryText="Compare Templates"
                          onTouchTap={() => push(`/contracting/reports/diff/template/${_id}?locationId=${locationId}&locationName=${locationName}`)}
                        />
                      </WallWrapper>
                    )
                  }
                  {
                    isTemplate && (
                      <MenuItem
                        leftIcon={<FontIcon className="tc-icon-content_copy" color="#00bcd4" />}
                        primaryText="Make a copy"
                        onTouchTap={() =>
                          openDialogSaveAsTemplate(_id, { startDate, endDate })
                        }
                      />
                    )
                  }
                </IconMenu>
              </div>
            </TableRowColumn>,
          ]
        : [
          <TableRowColumn
            key="errorText"
            colSpan="6"
            style={{ color: 'red', padding: 0, whiteSpace: 'pre-wrap' }}
          >
            {template.errorText}
          </TableRowColumn>,
          <TableRowColumn key="editState" colSpan="10" style={{ padding: 0 }}>
            <CancelConfirm
              callingApi={template.savingName}
              disableConfirmBtn={Boolean(
                template.showEditNameConfirmButton &&
                  (!template.newTemplateName ||
                    !template.newTemplateName.trim() ||
                    template.newTemplateName === template.templateName ||
                    template.errorText),
              )}
              forDelete={template.showDeleteConfirmButton}
              confirmLabel={template.showDeleteConfirmButton ? 'Yes, Delete' : 'Confirm Change'}
              cancelLabel="Nevermind"
              cancelFn={() =>
                updateTemplateProps({
                  showDeleteConfirmButton: false,
                  errorText: '',
                  showEditNameConfirmButton: false,
                  newTemplateName: '',
                })
              }
              confirmFn={
                template.showDeleteConfirmButton
                  ? deleteTemplate
                  : () => saveNewTemplateName(template.newTemplateName)
              }
            />
          </TableRowColumn>,
        ]}
    </TableRow>
  );
};

TemplateRow.propTypes = {
  companyName: PropTypes.string,
  isAccom: PropTypes.bool,
  template: PropTypes.object,
  actions: PropTypes.object,
  apiUrl: PropTypes.string,
  resourceType: PropTypes.string,
  showFolder: PropTypes.bool,
  updateProps: PropTypes.func,
  hoveringOverContractId: PropTypes.string,
  downloadContractPdf: PropTypes.func,
  push: PropTypes.func,
};

const mapStateToProps = ({ user }) => ({
  companyName: user.getIn(['company', 'companyName']),
});

export default connect(
  mapStateToProps,
  {
    push: pushAction,
    downloadContractPdf: downloadContractPdfAction,
    openDialogSaveAsTemplate: (contractId, contractYear) => ({ type: 'OPEN_AS_SAVE_CONTRACT_AS_TEMPLATE', payload: { contractId, contractYear } }),
  },
)(TemplateRow);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/ListRow.jsx